var map = {
	"./accessories/default.png": [
		21,
		4
	],
	"./accessories/earings.png": [
		22,
		5
	],
	"./accessories/flower.png": [
		23,
		6
	],
	"./accessories/glasses.png": [
		24,
		7
	],
	"./backgrounds/blue50.png": [
		25,
		8
	],
	"./backgrounds/blue60.png": [
		26,
		9
	],
	"./backgrounds/blue70.png": [
		27,
		10
	],
	"./backgrounds/darkblue30.png": [
		28,
		11
	],
	"./backgrounds/darkblue50.png": [
		29,
		12
	],
	"./backgrounds/darkblue70.png": [
		30,
		13
	],
	"./backgrounds/default.png": [
		31,
		14
	],
	"./backgrounds/green60.png": [
		32,
		15
	],
	"./backgrounds/green70.png": [
		33,
		16
	],
	"./backgrounds/grey40.png": [
		34,
		17
	],
	"./backgrounds/grey70.png": [
		35,
		18
	],
	"./backgrounds/grey80.png": [
		36,
		19
	],
	"./backgrounds/red50.png": [
		37,
		20
	],
	"./backgrounds/red60.png": [
		38,
		21
	],
	"./backgrounds/red70.png": [
		39,
		22
	],
	"./backgrounds/yellow50.png": [
		40,
		23
	],
	"./backgrounds/yellow60.png": [
		41,
		24
	],
	"./backgrounds/yellow70.png": [
		42,
		25
	],
	"./ears/default.png": [
		43,
		26
	],
	"./ears/tilt-backward.png": [
		44,
		27
	],
	"./ears/tilt-forward.png": [
		45,
		28
	],
	"./eyes/angry.png": [
		46,
		29
	],
	"./eyes/default.png": [
		47,
		30
	],
	"./eyes/naughty.png": [
		48,
		31
	],
	"./eyes/panda.png": [
		49,
		32
	],
	"./eyes/smart.png": [
		50,
		33
	],
	"./eyes/star.png": [
		51,
		34
	],
	"./hair/bang.png": [
		52,
		35
	],
	"./hair/curls.png": [
		53,
		36
	],
	"./hair/default.png": [
		54,
		37
	],
	"./hair/elegant.png": [
		55,
		38
	],
	"./hair/fancy.png": [
		56,
		39
	],
	"./hair/quiff.png": [
		57,
		40
	],
	"./hair/short.png": [
		58,
		41
	],
	"./leg/bubble-tea.png": [
		59,
		42
	],
	"./leg/cookie.png": [
		60,
		43
	],
	"./leg/default.png": [
		61,
		44
	],
	"./leg/game-console.png": [
		62,
		45
	],
	"./leg/tilt-backward.png": [
		63,
		46
	],
	"./leg/tilt-forward.png": [
		64,
		47
	],
	"./mouth/astonished.png": [
		65,
		48
	],
	"./mouth/default.png": [
		66,
		49
	],
	"./mouth/eating.png": [
		67,
		50
	],
	"./mouth/laugh.png": [
		68,
		51
	],
	"./mouth/tongue.png": [
		69,
		52
	],
	"./neck/bend-backward.png": [
		70,
		53
	],
	"./neck/bend-forward.png": [
		71,
		54
	],
	"./neck/default.png": [
		72,
		55
	],
	"./neck/thick.png": [
		73,
		56
	],
	"./nose/default.png": [
		74,
		57
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 18;
module.exports = webpackAsyncContext;